import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = { class: "tab-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tab-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab.name,
          class: _normalizeClass(['tab-button', { active: _ctx.selectedValue === tab.name }]),
          onClick: ($event: any) => (_ctx.selectTab(tab.name))
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, _ctx.selectedValue, {}, undefined, true)
    ])
  ]))
}